import React from "react";
import {
    MARKET_TILE_OPTIONS,
    STATUS_TILE_OPTIONS,
    showsMarketRow,
    toggleSingleTile,
    toggleTile,
} from "../utils/propertyTiles";

function FilterTabGroup({ label, options, selected, onSelect, toggle = toggleTile }) {
    // Multi-select again, on purpose this time. Christian Gravias, 1 Oct 2026:
    // "make this where an agent can click more then 1 tile on or off if they
    // want so they can have on market & off market & appraisal or they can just
    // click 1 tile if they want." Clicking a lit tile switches it off, and
    // "All" clears the row, so a second tile is never stuck on by accident.
    return (
        <div className="flex flex-col gap-1.5 md:flex-row md:items-center md:gap-3">
            <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider md:shrink-0 md:w-[100px]">{label}</span>
            <div className="flex flex-wrap items-center gap-2 sm:gap-3 md:gap-2">
                {options.map((option) => {
                    const active = selected.includes(option.id);
                    return (
                        <button
                            key={option.id}
                            type="button"
                            aria-pressed={active}
                            onClick={() => onSelect(toggle(selected, option.id))}
                            className={`px-4 sm:px-6 md:px-4 py-2 sm:py-2.5 md:py-2 rounded-lg text-xs sm:text-sm font-bold transition-all border ${active
                                ? "bg-[#55C5D0] border-[#55C5D0] text-white shadow-sm"
                                : "bg-white border-gray-200 text-[#36423F] hover:border-[#55C5D0] hover:text-[#55C5D0]"
                                }`}
                        >
                            {option.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

// Shared Status / Market tile bar used by both the My Listings and Collings
// Properties pages, so the two can't drift apart into different button sets again.
export default function PropertyFilterTabs({
    selectedStatuses,
    setSelectedStatuses,
    selectedMarkets,
    setSelectedMarkets,
    statusOptions = STATUS_TILE_OPTIONS,
    marketOptions = MARKET_TILE_OPTIONS,
}) {
    const handleStatusSelect = (next) => {
        setSelectedStatuses(next);
        // The Market row disappears once neither For Sale nor For Lease is lit.
        // Put it back to All then, so a hidden Off Market pick can't quietly
        // narrow the list the next time For Sale is switched on.
        if (!showsMarketRow(next) && !selectedMarkets.includes("all")) {
            setSelectedMarkets(["all"]);
        }
    };

    return (
        <div className="flex flex-col gap-3">
            <FilterTabGroup
                label="Status"
                options={statusOptions}
                selected={selectedStatuses}
                onSelect={handleStatusSelect}
            />
            {showsMarketRow(selectedStatuses) && (
                <FilterTabGroup
                    label="Market"
                    options={marketOptions}
                    selected={selectedMarkets}
                    onSelect={setSelectedMarkets}
                    // On Market and Off Market can't both be lit - that is just All.
                    toggle={toggleSingleTile}
                />
            )}
        </div>
    );
}
